<template>
    <div class="action-bar">
        <div class="action-bar_right">
            <div v-for="item in actionList" :key="item.type">
                <el-tooltip class="box-item" :content="item.name" placement="top" effect="customized">
                    <div class="action-box">
                        <div>
                            <svg-icon v-if="item.type === 1" :name="item.icon" class="svg-icon move" />
                            <svg-icon v-else @click="item.onclick(item)" :name="item.icon" class="svg-icon" />
                        </div>
                    </div>
                </el-tooltip>
            </div>
        </div>
        <slot name="operation" />
        <!-- 确认删除弹框 -->
        <delete-dialog ref="deleteDialog" @confirmDelete="confirmDelete" />
    </div>
</template>
<script setup>
import { ref, inject } from "vue";
import DeleteDialog from "../dialog/DeleteDialog.vue";
const emit = defineEmits(["addCopy", "deleteQuestion", "view"]);
const deleteDialog = ref(null);
const actionList = ref([
    { type: 2, name: "预览题目", icon: "views", onclick: (e) => emit("view", e) },
    { type: 1, name: "长按拖动题目进行排序", icon: "drag", selectShow: false },
    { type: 4, name: "复制题目", icon: "copy", onclick: () => addCopy() },
    {
        type: 5,
        name: "删除题目",
        icon: "delete",
        selectShow: false,
        onclick: (e) => deleteQuestion(e),
    },
]);
const itemView = (e) => {};
// 复制
const addCopy = () => {
    emit("addCopy");
};
// 点击删除按钮
const deleteQuestion = () => {
    deleteDialog.value.deleteDialogVisible = true;
};
const confirmDelete = () => {
    // 在最外层组件调用删除逻辑
    emit("deleteQuestion");
};
</script>
<style>
.el-popper.is-customized {
    /* Set padding to ensure the height is 32px */
    border: 1px solid rgba(34, 64, 195, 0.8);
    background-color: #fff;
}

.el-popper.is-customized .el-popper__arrow::before {
    border: 1px solid rgba(34, 64, 195, 0.8);
    background-color: #fff;
    right: 0;
}
</style>
<style lang="scss" scoped>
@use "@/css/reset.scss" as *;
.action-bar {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .action-bar_right {
        display: flex;
        .action-box {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-left: 18px;
            cursor: pointer;
            .svg-icon {
                width: 30px;
                height: 30px;
            }
        }
    }
}
</style>
